import { globalColorsTheme } from '../globalColors';

export const themeColors = {
  background: {
    primary: globalColorsTheme.neutral.neutral100,
    secondary: globalColorsTheme.neutral.neutral200
  },
  surface: {
    primary: globalColorsTheme.neutral.neutral100,
    primaryHover: globalColorsTheme.neutral.neutral300,
    primaryPressed: globalColorsTheme.neutral.neutral400,
    primarySelected: globalColorsTheme.informative.informative100,
    primaryDisabled: globalColorsTheme.neutral.neutral300,
    secondary: globalColorsTheme.neutral.neutral200,
    secondaryHover: globalColorsTheme.neutral.neutral400,
    secondaryPressed: globalColorsTheme.neutral.neutral500,
    secondarySelected: globalColorsTheme.informative.informative100,
    secondaryDisabled: globalColorsTheme.neutral.neutral300,
    inverse: globalColorsTheme.neutral.neutral1000
  },

  action: {
    primary: globalColorsTheme.informative.informative700,
    primaryHover: globalColorsTheme.informative.informative800,
    primaryPressed: globalColorsTheme.informative.informative900,
    primaryDisabled: globalColorsTheme.neutral.neutral300,

    secondary: globalColorsTheme.neutral.neutral100,
    secondaryHover: globalColorsTheme.neutral.neutral200,
    secondaryPressed: globalColorsTheme.informative.informative100,
    secondaryDisabled: globalColorsTheme.neutral.neutral300,

    tertiary: globalColorsTheme.neutral.neutral100,
    tertiaryHover: globalColorsTheme.neutral.neutral200,
    tertiaryPressed: globalColorsTheme.informative.informative100,
    tertiaryDisabled: globalColorsTheme.neutral.neutral300,

    criticalPrimary: globalColorsTheme.critical.critical700,
    criticalPrimaryHover: globalColorsTheme.critical.critical800,
    criticalPrimaryPressed: globalColorsTheme.critical.critical900,
    criticalPrimaryDisabled: globalColorsTheme.neutral.neutral300,

    criticalSecondary: globalColorsTheme.neutral.neutral100,
    criticalSecondaryHover: globalColorsTheme.critical.critical100,
    criticalSecondaryPressed: globalColorsTheme.critical.critical200,
    criticalSecondaryDisabled: globalColorsTheme.neutral.neutral300,

    positive: globalColorsTheme.positive.positive700,
    positiveHover: globalColorsTheme.positive.positive800,
    positivePressed: globalColorsTheme.positive.positive900,
    positiveDisabled: globalColorsTheme.neutral.neutral300,

    positiveSecondary: globalColorsTheme.neutral.neutral100,
    positiveSecondaryHover: globalColorsTheme.positive.positive100,
    positiveSecondaryPressed: globalColorsTheme.positive.positive200,
    positiveSecondaryDisabled: globalColorsTheme.neutral.neutral300,

    warningPrimary: globalColorsTheme.warning.warning600,
    warningPrimaryHover: globalColorsTheme.warning.warning700,
    warningPrimaryPressed: globalColorsTheme.warning.warning800,
    warningPrimaryDisabled: globalColorsTheme.neutral.neutral300
  },
  fill: {
    primary: globalColorsTheme.neutral.neutral100,
    secondary: globalColorsTheme.neutral.neutral300,
    tertiary: globalColorsTheme.neutral.neutral400,
    disabled: globalColorsTheme.neutral.neutral300,
    inverse: globalColorsTheme.neutral.neutral1000,
    readonly: globalColorsTheme.neutral.neutral700,

    brandPrimary: globalColorsTheme.informative.informative700,
    brandSecondary: globalColorsTheme.informative.informative100,

    infoPrimary: globalColorsTheme.informative.informative700,
    infoSecondary: globalColorsTheme.informative.informative100,
    infoTertiary: globalColorsTheme.neutral.neutral400,

    criticalPrimary: globalColorsTheme.critical.critical700,
    criticalSecondary: globalColorsTheme.critical.critical100,

    successPrimary: globalColorsTheme.positive.positive700,
    successSecondary: globalColorsTheme.positive.positive100,

    warningPrimary: globalColorsTheme.warning.warning600,
    warningSecondary: globalColorsTheme.warning.warning100,
    warningTertiary: globalColorsTheme.warning.warning300,
    decorative1: globalColorsTheme.decorative.decorative1,
    decorative2: globalColorsTheme.decorative.decorative2,
    decorative3: globalColorsTheme.decorative.decorative3,
    decorative4: globalColorsTheme.decorative.decorative4,
    decorative5: globalColorsTheme.decorative.decorative5,
    decorative6: globalColorsTheme.decorative.decorative6,
    decorative7: globalColorsTheme.decorative.decorative7,
    decorative8: globalColorsTheme.decorative.decorative8,
    decorative9: globalColorsTheme.decorative.decorative9,
    decorative10: globalColorsTheme.decorative.decorative10,
    decorative11: globalColorsTheme.decorative.decorative11,
    decorative12: globalColorsTheme.decorative.decorative12
  },
  text: {
    primary: globalColorsTheme.neutral.neutral1000,
    secondary: globalColorsTheme.neutral.neutral700,
    inverse: globalColorsTheme.neutral.neutral100,
    disabled: globalColorsTheme.neutral.neutral500,
    brand: globalColorsTheme.informative.informative700,
    brandHover: globalColorsTheme.informative.informative800,
    brandPressed: globalColorsTheme.informative.informative900,
    info: globalColorsTheme.informative.informative700,
    infoHover: globalColorsTheme.informative.informative800,
    infoPressed: globalColorsTheme.informative.informative900,
    infoOnColor: globalColorsTheme.informative.informative900,
    critical: globalColorsTheme.critical.critical700,
    criticalHover: globalColorsTheme.critical.critical800,
    criticalPressed: globalColorsTheme.critical.critical900,
    criticalOnColor: globalColorsTheme.critical.critical900,
    success: globalColorsTheme.positive.positive700,
    successHover: globalColorsTheme.positive.positive800,
    successPressed: globalColorsTheme.positive.positive900,
    successOnColor: globalColorsTheme.positive.positive900,
    decorative1: globalColorsTheme.decorative.decorative1,
    decorative2: globalColorsTheme.decorative.decorative2,
    decorative3: globalColorsTheme.decorative.decorative3,
    decorative4: globalColorsTheme.decorative.decorative4,
    decorative5: globalColorsTheme.decorative.decorative5,
    decorative6: globalColorsTheme.decorative.decorative6,
    decorative7: globalColorsTheme.decorative.decorative7,
    decorative8: globalColorsTheme.decorative.decorative8,
    decorative9: globalColorsTheme.decorative.decorative9,
    decorative10: globalColorsTheme.decorative.decorative10,
    decorative11: globalColorsTheme.decorative.decorative11,
    decorative12: globalColorsTheme.decorative.decorative12,
    decorative13: globalColorsTheme.decorative.decorative13,
    decorative14: globalColorsTheme.decorative.decorative14
  },
  link: {
    primary: globalColorsTheme.informative.informative700,
    primaryHover: globalColorsTheme.informative.informative800,
    primaryPressed: globalColorsTheme.informative.informative900,
    primaryDisabled: globalColorsTheme.neutral.neutral500,
    inverse: globalColorsTheme.neutral.neutral100,
    inverseHover: globalColorsTheme.neutral.neutralA80,
    inversePressed: globalColorsTheme.neutral.neutralA60,
    inverseDisabled: globalColorsTheme.neutral.neutralA35
  },

  border: {
    static: globalColorsTheme.neutral.neutral400,
    interactive: globalColorsTheme.neutral.neutral600,
    interactiveHover: globalColorsTheme.neutral.neutral1000,
    interactiveSelected: globalColorsTheme.informative.informative700,
    interactiveDisabled: globalColorsTheme.neutral.neutral400,
    inverse: globalColorsTheme.neutral.neutral100,
    info: globalColorsTheme.informative.informative700,
    critical: globalColorsTheme.critical.critical700,
    success: globalColorsTheme.positive.positive700,
    warning: globalColorsTheme.warning.warning700,
    neutral: globalColorsTheme.neutral.neutral1000
  },
  icon: {
    primary: globalColorsTheme.neutral.neutral1000,
    secondary: globalColorsTheme.neutral.neutral800,
    disabled: globalColorsTheme.neutral.neutral500,
    inverse: globalColorsTheme.neutral.neutral100,
    inverseDisabled: globalColorsTheme.neutral.neutralA35,
    readonly: globalColorsTheme.neutral.neutral700,
    brand: globalColorsTheme.informative.informative700,
    link: globalColorsTheme.informative.informative700,
    info: globalColorsTheme.informative.informative700,
    critical: globalColorsTheme.critical.critical700,
    success: globalColorsTheme.positive.positive700,
    warning: globalColorsTheme.warning.warning700
  },
  illustration: {
    background: globalColorsTheme.neutral.neutral100,
    border: globalColorsTheme.neutral.neutral1000,
    decorative1: globalColorsTheme.informative.informative600,
    decorative2: globalColorsTheme.informative.informative300,
    decorative3: globalColorsTheme.warning.warning100
  },
  navigation: {
    backgroundDefault: globalColorsTheme.neutral.neutral1000,
    backgroundSelected: globalColorsTheme.neutral.neutral900,
    mainIconFill: globalColorsTheme.informative.informative700,
    mainIconText: globalColorsTheme.neutral.neutral100,
    iconDefault: globalColorsTheme.neutral.neutral400,
    iconSelected: globalColorsTheme.neutral.neutral100
  }
};
